import React from 'react'

// Images
import img from '../../assets/images/offer/Img.jpg'
import img2X from '../../assets/images/offer/Img@2x.png'
import img2 from '../../assets/images/offer/Img2.jpg'
import img22X from '../../assets/images/offer/Img2@2x.jpg'
import img3 from '../../assets/images/offer/Img3.jpg'
import img32X from '../../assets/images/offer/Img3@2x.jpg'
import img4 from '../../assets/images/offer/Img4.jpg'
import img42X from '../../assets/images/offer/Img4@2x.jpg'
import img5 from '../../assets/images/offer/Img5.jpg'
import img52X from '../../assets/images/offer/Img5@2x.jpg'
import img6 from '../../assets/images/offer/Img6.jpg'
import img62X from '../../assets/images/offer/Img6@2x.jpg'

// Icons
import { ReactComponent as IconDrag } from '../../assets/icons/icon-drag.svg'
import { Trans } from 'react-i18next'

class Offer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      interval: null,
      isMouseOver: false,
      isMouseDown: false,
      cursorPosition: 0,
      scrollPosition: 0,
      location: ''
    }
  }

  ref = React.createRef()

  componentDidMount = () => {
    this.playCarousel()

    if (window !== null) {
      this.setState({
        location: window.location.pathname
      })
    }
  }

  componentWillUnmount = () => {
    this.pauseCarousel()
  }

  playCarousel = () => {
    const interval = setInterval(() => {
      this.ref.current.scrollLeft = this.ref.current.scrollLeft + 1
    }, 30)

    if (this.state.interval === null) {
      this.setState({
        interval: interval
      })
    }
  }

  pauseCarousel = () => {
    clearInterval(this.state.interval)
    this.setState({
      interval: null
    })
  }

  handleMouseOver = () => {
    if (!this.state.isMouseOver) {
      this.setState({
        isMouseOver: true
      })
    }

    this.pauseCarousel()
  }

  handleMouseLeave = () => {
    if (this.state.isMouseOver) {
      this.setState({
        isMouseOver: false
      })
    }

    const cursor = document.getElementById('dragCursor')
    cursor.style.opacity = 0

    this.playCarousel()
  }

  handleMouseDown = (event) => {
    const newCursorPosition = event.pageX - this.ref.current.offsetLeft
    const newScrollPosition = this.ref.current.scrollLeft

    this.setState({
      isMouseDown: true,
      cursorPosition: newCursorPosition,
      scrollPosition: newScrollPosition
    })
  }

  handleMouseUp = () => {
    this.setState({
      isMouseDown: false
    })
  }

  handleMouseMove = (event) => {
    if (this.state.isMouseDown) {
      event.preventDefault()
      const x = event.pageX - this.ref.current.offsetLeft
      const walk = x - this.state.cursorPosition
      this.ref.current.scrollLeft = this.state.scrollPosition - walk
    }

    // Cursor movement
    const xCoord = event.pageX
    const yCoord = event.pageY

    // Follows cursor
    const cursor = document.getElementById('dragCursor')
    cursor.style.opacity = 1
    cursor.style.top = yCoord - 50 + 'px'
    cursor.style.left = xCoord - 50 + 'px'
  }

  render = () => (
    <div className="offer" data-aos="fade">
      <div className="container">
        <div className="offer__info row justify-content-center">
          <div className="col-12 col-sm-5">
            <h2 className="offer__title">
              <Trans i18nKey="offer.title" />
            </h2>
          </div>
          <div className="offer__text col-12 col-md-5">
            <p>
              <Trans i18nKey="offer.description" />
            </p>
            <p className="offer__reserva">
              <a className="button__secondary" href="https://www.facebook.com/margotrestostafe/" target="_blank" rel="noopener noreferrer">
                <Trans i18nKey="offer.ctaLabel" />
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className={this.state.location === '/en' ? 'offer__cards offer__cards--en' : 'offer__cards'} onMouseDown={this.handleMouseDown} onMouseUp={this.handleMouseUp} onMouseMove={this.handleMouseMove} onMouseOver={this.handleMouseOver} onFocus={this.handleMouseOver} onMouseLeave={this.handleMouseLeave} ref={this.ref} role="button" aria-hidden="true">
        <IconDrag id="dragCursor" />
        <div className="card">
          <img src={img} srcSet={img2X + ' 2x'} alt="respeto"></img>
          <p className="card__title">
            <Trans i18nKey="offer.cards.respeto.title" />
          </p>
          <p className="card__text">
            <Trans i18nKey="offer.cards.respeto.description" />
          </p>
        </div>
        <div className="card">
          <img src={img2} srcSet={img22X + ' 2x'} alt="exclusividad"></img>
          <p className="card__title">
            <Trans i18nKey="offer.cards.exclusividad.title" />
          </p>
          <p className="card__text">
            <Trans i18nKey="offer.cards.exclusividad.description" />
          </p>
        </div>
        <div className="card">
          <img src={img3} srcSet={img32X + ' 2x'} alt="calidad"></img>
          <p className="card__title">
            <Trans i18nKey="offer.cards.calidad.title" />
          </p>
          <p className="card__text">
            <Trans i18nKey="offer.cards.calidad.description" />
          </p>
        </div>
        <div className="card">
          <img src={img4} srcSet={img42X + ' 2x'} alt="personalizacion"></img>
          <p className="card__title">
            <Trans i18nKey="offer.cards.personalizacion.title" />
          </p>
          <p className="card__text">
            <Trans i18nKey="offer.cards.personalizacion.description" />
          </p>
        </div>
        <div className="card">
          <img src={img5} srcSet={img52X + ' 2x'} alt="vanguardia"></img>
          <p className="card__title">
            <Trans i18nKey="offer.cards.vanguardia.title" />
          </p>
          <p className="card__text">
            <Trans i18nKey="offer.cards.vanguardia.description" />
          </p>
        </div>
        <div className="card">
          <img src={img6} srcSet={img62X + ' 2x'} alt="autenticidad"></img>
          <p className="card__title">
            <Trans i18nKey="offer.cards.autenticidad.title" />
          </p>
          <p className="card__text">
            <Trans i18nKey="offer.cards.autenticidad.description" />
          </p>
        </div>

        <div className="card">
          <img src={img} srcSet={img2X + ' 2x'} alt="respeto"></img>
          <p className="card__title">
            <Trans i18nKey="offer.cards.respeto.title" />
          </p>
          <p className="card__text">
            <Trans i18nKey="offer.cards.respeto.description" />
          </p>
        </div>
        <div className="card">
          <img src={img2} srcSet={img22X + ' 2x'} alt="exclusividad"></img>
          <p className="card__title">
            <Trans i18nKey="offer.cards.exclusividad.title" />
          </p>
          <p className="card__text">
            <Trans i18nKey="offer.cards.exclusividad.description" />
          </p>
        </div>
        <div className="card">
          <img src={img3} srcSet={img32X + ' 2x'} alt="calidad"></img>
          <p className="card__title">
            <Trans i18nKey="offer.cards.calidad.title" />
          </p>
          <p className="card__text">
            <Trans i18nKey="offer.cards.calidad.description" />
          </p>
        </div>
        <div className="card">
          <img src={img4} srcSet={img42X + ' 2x'} alt="personalizacion"></img>
          <p className="card__title">
            <Trans i18nKey="offer.cards.personalizacion.title" />
          </p>
          <p className="card__text">
            <Trans i18nKey="offer.cards.personalizacion.description" />
          </p>
        </div>
        <div className="card">
          <img src={img5} srcSet={img52X + ' 2x'} alt="vanguardia"></img>
          <p className="card__title">
            <Trans i18nKey="offer.cards.vanguardia.title" />
          </p>
          <p className="card__text">
            <Trans i18nKey="offer.cards.vanguardia.description" />
          </p>
        </div>
        <div className="card">
          <img src={img6} srcSet={img62X + ' 2x'} alt="autenticidad"></img>
          <p className="card__title">
            <Trans i18nKey="offer.cards.autenticidad.title" />
          </p>
          <p className="card__text">
            <Trans i18nKey="offer.cards.autenticidad.description" />
          </p>
        </div>

        <div className="card">
          <img src={img} srcSet={img2X + ' 2x'} alt="respeto"></img>
          <p className="card__title">
            <Trans i18nKey="offer.cards.respeto.title" />
          </p>
          <p className="card__text">
            <Trans i18nKey="offer.cards.respeto.description" />
          </p>
        </div>
        <div className="card">
          <img src={img2} srcSet={img22X + ' 2x'} alt="exclusividad"></img>
          <p className="card__title">
            <Trans i18nKey="offer.cards.exclusividad.title" />
          </p>
          <p className="card__text">
            <Trans i18nKey="offer.cards.exclusividad.description" />
          </p>
        </div>
        <div className="card">
          <img src={img3} srcSet={img32X + ' 2x'} alt="calidad"></img>
          <p className="card__title">
            <Trans i18nKey="offer.cards.calidad.title" />
          </p>
          <p className="card__text">
            <Trans i18nKey="offer.cards.calidad.description" />
          </p>
        </div>
        <div className="card">
          <img src={img4} srcSet={img42X + ' 2x'} alt="personalizacion"></img>
          <p className="card__title">
            <Trans i18nKey="offer.cards.personalizacion.title" />
          </p>
          <p className="card__text">
            <Trans i18nKey="offer.cards.personalizacion.description" />
          </p>
        </div>
        <div className="card">
          <img src={img5} srcSet={img52X + ' 2x'} alt="vanguardia"></img>
          <p className="card__title">
            <Trans i18nKey="offer.cards.vanguardia.title" />
          </p>
          <p className="card__text">
            <Trans i18nKey="offer.cards.vanguardia.description" />
          </p>
        </div>
        <div className="card">
          <img src={img6} srcSet={img62X + ' 2x'} alt="autenticidad"></img>
          <p className="card__title">
            <Trans i18nKey="offer.cards.autenticidad.title" />
          </p>
          <p className="card__text">
            <Trans i18nKey="offer.cards.autenticidad.description" />
          </p>
        </div>
      </div>
    </div>
  )
}
export default Offer
